import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import './Auth.css';

export default function ResetPassword({ navigateTo }) {
  const { resetPassword } = useAuth();
  const [token, setToken] = useState(() => new URLSearchParams(window.location.search).get('token') || '');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!token) {
      setError('لطفاً توکن دریافتی را وارد کنید');
      return;
    }

    if (!password || password.length < 8) {
      setError('رمز عبور باید حداقل 8 کاراکتر باشد');
      return;
    }

    if (password !== confirmPassword) {
      setError('رمز عبور با تکرار آن مطابقت ندارد');
      return;
    }

    setLoading(true);

    try {
      const result = await resetPassword(token, password);
      if (result.success) {
        setSuccess(result.message);
        setTimeout(() => navigateTo('login'), 2000);
      } else {
        setError(result.message);
      }
    } catch (resetError) {
      setError(resetError.response?.data?.message || 'تغییر رمز انجام نشد');
    } finally { setLoading(false); }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h2>بازنشانی رمز عبور</h2>
          <p>توکن و رمز عبور جدید را وارد کنید</p>
        </div>

        <div className="auth-body">
          {error && <div className="error-message">{error}</div>}
          {success && <div className="success-message">{success}</div>}

          <form onSubmit={handleSubmit}>
            {!new URLSearchParams(window.location.search).get('token') && <div className="form-group">
              <label>توکن بازیابی</label>
              <input
                type="text"
                value={token}
                onChange={(e) => setToken(e.target.value)}
                placeholder="توکن را از کنسول کپی کنید"
                dir="ltr"
              />
            </div>}

            <div className="form-group">
              <label>رمز عبور جدید (حداقل 8 کاراکتر)</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="********"
                dir="ltr"
              />
            </div>

            <div className="form-group">
              <label>تکرار رمز عبور جدید</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="********"
                dir="ltr"
              />
            </div>

            <button type="submit" className="auth-button" disabled={loading}>
              {loading ? 'در حال تغییر...' : 'تغییر رمز عبور'}
            </button>
          </form>
        </div>

        <div className="auth-footer">
          <button onClick={() => navigateTo('login')}>بازگشت به صفحه ورود</button>
        </div>
      </div>
    </div>
  );
}
